(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6845:
/***/ (() => {



/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Surface)
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/Surface/Surface.tsx


/**
 * Surfaces are used to provide depth and mimic real world environments to increase comprehension.
 *
 * [View the Surface pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Surface)
 *
 * @version 1.0.0
 * @param props
 */
function Surface(props) {
  var interactive = props.interactive,
    _props$cornerRadius = props.cornerRadius,
    cornerRadius = _props$cornerRadius === void 0 ? 'cornerRadiusSlight' : _props$cornerRadius,
    background = props.background;
  var className = props.className,
    children = props.children,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'SurfaceMid' : _props$variant,
    _props$hasBorder = props.hasBorder,
    hasBorder = _props$hasBorder === void 0 ? false : _props$hasBorder;
  var patternClass = 'able-Surface';
  var isFlat = variant === 'SurfaceFlat';
  // the following conforms to rules in confluence specs
  if (!isFlat) {
    if (cornerRadius === 'cornerRadiusNone') {
      cornerRadius = 'cornerRadiusSlight';
    }
    if (background !== 'materialBasePrimary') {
      background = 'materialBasePrimary';
    }
  }
  if (interactive) {
    if (isFlat || variant === 'SurfaceTop') {
      interactive = false;
    }
  }
  var borderAllowed = variant === 'SurfaceFlat' && background === 'materialBasePrimary';
  var borderClass = '';
  if (hasBorder) {
    if (borderAllowed) {
      borderClass = 'able-Surface--border';
    } else {
      console.error('ABLE Surface: component is ineligible to display a border. Currently only SurfaceFlat variant with background colour materialBasePrimary supports border.');
    }
  }
  var classes = classnames_default()(patternClass, "".concat(patternClass, "--").concat(variant, "--").concat(cornerRadius, "--").concat(background), "".concat(interactive ? "".concat(patternClass, "--").concat(variant, "--").concat(cornerRadius, "--interactive") : '', " "), borderClass, className);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: classes,
    children: children
  });
}
Surface.displayName = 'Surface';
/* harmony default export */ const Surface_Surface = (Surface);
// EXTERNAL MODULE: ./src/Surface/Surface.scss
var src_Surface_Surface = __webpack_require__(6845);
;// ./src/Surface/index.ts


/* harmony default export */ const src_Surface = (Surface_Surface);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});